import * as React from 'react';

const { useEffect, useState, useRef } = React;

// used to render large lists on dom efficiently
/*
  @param domSelector - root/ancestor element
  @param handleLoading - pass true to stop watching the oberserver when loaded on dom
*/
export const useInterSectionObserver = (domSelector, handleLoading = false): any => {
  const [isLoaded, setLoaded] = useState(false);
  const elRef: React.MutableRefObject<any> = useRef();
  useEffect(() => {
    /* https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver
      the Intersection Observer API provides a way to asynchronously observe changes
      in the intersection of a target element with an ancestor element
      or with a top-level document’s viewport
      the first argument callback will be invoked whenever target element intersects
      with root/ancestor
    */
    let observer: any = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const { isIntersecting } = entry;
          // set state loaded true if traget element intersects with root
          if (isIntersecting) {
            setLoaded(true);
            // disconnect the observer handleLoading set to false
            if (!handleLoading) {
              observer = observer.disconnect();
            }
          } else if (handleLoading) {
            // set state loaded false if handleLoading set to true
            setLoaded(false);
          }
        });
      },
      {
        root: document.querySelector(domSelector), // root element of the target element to observe
      },
    );
    observer.observe(elRef.current); // observe the target element
  }, []);

  return [isLoaded, elRef];
};
